import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.65394 5.19279C4.64233 3.35457 6.12299 1.85502 7.96121 1.84335C9.79944 1.83168 11.299 3.31238 11.3107 5.15062L11.3181 6.32911C11.3199 6.60525 11.0974 6.83052 10.8213 6.83227C10.5452 6.83402 10.3199 6.61158 10.3182 6.33544L10.3107 5.15696C10.3025 3.87098 9.2535 2.83516 7.96756 2.84333C6.68161 2.8515 5.6458 3.90051 5.65392 5.18646L5.66139 6.36495C5.66314 6.64109 5.4407 6.86636 5.16457 6.86811C4.88843 6.86986 4.66316 6.64742 4.66141 6.37128L4.65394 5.19279Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.17914 9.16789C5.45528 9.16614 5.68055 9.38858 5.6823 9.66471L5.68976 10.8432C5.69793 12.1291 6.74695 13.165 8.0329 13.1568C9.31884 13.1487 10.3547 12.0997 10.3465 10.8137L10.3391 9.63521C10.3373 9.35908 10.5597 9.1338 10.8359 9.13205C11.112 9.1303 11.3373 9.35274 11.339 9.62888L11.3465 10.8074C11.3581 12.6456 9.87746 14.1452 8.03922 14.1568C6.20101 14.1684 4.70146 12.6878 4.68978 10.8495L4.68232 9.67105C4.68057 9.39491 4.903 9.16964 5.17914 9.16789Z"
      fill="currentColor"
    />
  </SvgIcon>
));
